// removed by extract-text-webpack-plugin
module.exports = {"commentForm":"mvL-i","header":"_1B4Iy","content":"_2s-_j","editDate":"_2Dnkq","buttonContainer":"Ui2vj","editorControlsWrapper":"_1KRCs"};


//////////////////
// WEBPACK FOOTER
// ./app/components/comment-form/comment-form.scss
// module id = 1568
// module chunks = 0